<div class="mi-error-page d-flex flex-column align-items-center">
    <div>
        <img src="assets/images/general/error/errorPage.svg" alt="error page">
    </div>
    <div>
        <p class="fw-bold">{{errorText?.errorPage?.text|mcFormatText:errorPageCode}}</p>
    </div>
    <div>
        <small>{{errorText?.errorPage?.smallText}}</small>
    </div>
</div>